import React from 'react';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { buildShowMoreLabel } from '../../../utils/buildShowMoreLabel';
import { ShowMoreTagsItemProps } from '../../../types';
import { useTagsContext } from '../TagsContext/TagsContext';

export const DefaultShowMoreTagsItemProps: React.FC<ShowMoreTagsItemProps> = ({ onClickShowMore }) => {
    const { tagsLayout, hiddenTagsCount } = useTagsContext();
    const showMoreText = buildShowMoreLabel(hiddenTagsCount);

    if (hiddenTagsCount <= 0) {
        return null;
    }

    return (
        <Stack
            paddingY={tagsLayout.paddingY}
            paddingX={tagsLayout.paddingX}
            backgroundColor="grey_200"
            borderRadius="circle"
        >
            <Text size={tagsLayout.fontSize} onClick={onClickShowMore} cursor="pointer">
                {showMoreText}
            </Text>
        </Stack>
    );
};
